import { Box, Grid } from "@mui/material";
import { Header, SignOutModal } from "components/UI";
import { useChurchStore } from "features/churches";
import { useUser } from "features/users";
import { useEffect } from "react";
import { useAuthUser, useSignOut } from "react-auth-kit";
import { Outlet } from "react-router-dom";
import { DenominationProfileSidebar } from "./DenominationProfileSidebar";

export function DenominationProfileLayout() {
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const auth = useAuthUser();
  const signOut = useSignOut();

  const userQuery = useUser({
    churchId: selectedChurch?.id,
    userId: auth()?.id
  });

  useEffect(() => {
    if (userQuery.data && !userQuery.data?.result?.account_users?.[0]?.status) {
      signOut();
    }
  }, [userQuery.data]);

  return (
    <Grid container component="main" sx={{ minHeight: "100vh" }}>
      <SignOutModal />
      <Grid item xs={false} sm={4} md={2}>
        <DenominationProfileSidebar />
      </Grid>
      <Grid
        item
        xs={12}
        sm={8}
        md={10}
        sx={{ height: "100vh", overflowY: "auto" }}
      >
        <Header />
        <Box
          sx={{
            pb: 6,
            px: 4,
            my: "auto"
          }}
        >
          <Outlet />
        </Box>
      </Grid>
    </Grid>
  );
}
